import SelectBoxTrangThaiDangHoc, { StudentFilterType, ISelectBoxTrangThaiDangHocProps } from "./SelectBoxTrangThaiDangHoc";

export type { StudentFilterType, ISelectBoxTrangThaiDangHocProps };
export default SelectBoxTrangThaiDangHoc;
